import { createPortal } from "react-dom";
import "../styles/CommentsModel.css"

export default function CommentsModal({ patient, comments = [], onClose, onOpenDashboard, onOpenStudy }) {
  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="simple-modal" onClick={(e) => e.stopPropagation()}>
        <div className="simple-modal-header">
          <h3>{patient.patient}</h3>
        </div>
        <div className="simple-modal-body">
          {comments.map((item, i) => (
            <div key={i} className="comment-item">
              <p className="comment-user">ADMIN</p>
              <p className="comment-text">{item.message}</p>
            </div>
          ))}
        </div>
        <div className="simple-modal-input-row">
          <span className="user-icon">👤</span>
          <input type="text" placeholder="Type a message" />
          <button className="send-btn">➤</button>
        </div>
        <div className="simple-modal-footer">
          <button className="dashboard-btn" onClick={onOpenDashboard}>OPEN DASHBOARD</button>
          <button className="open-study-btn" onClick={onOpenStudy}>OPEN STUDY</button>
          <button className="close-btn" onClick={onClose}>CLOSE</button>
        </div>
      </div>
    </div>,
    document.body
  );
}